import React, { useState } from "react";
import axios from "axios";
import CONFIG from "./config";
import CustomAlert from "./CustomAlert";
import { useNavigate, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import "./AddbBlogform.css";
import { ToastContainer } from "react-toastify";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FaTimes } from "react-icons/fa";

const AddBlogForm = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Extract blog data from location state (if editing)
  const blogData = location.state?.blog || {
    image: null,
    title: "",
    description: "",
  };
  const isEditing = location.state?.isEditing || false;
  const blogId = location.state?.blog?._id || null;

  const [newBlog, setNewBlog] = useState(blogData);
  const [alert, setAlert] = useState(null);

  const [imagePreview, setImagePreview] = useState(
    blogData.imagePath ? blogData.imagePath : ""
  );

  const handleInputChange = (e) => {
    const { name, value, files } = e.target;

    if (name === "image" && files.length > 0) {
      const file = files[0];
      setImagePreview(URL.createObjectURL(file));
      setNewBlog({ ...newBlog, image: file });
    } else {
      setNewBlog({ ...newBlog, [name]: value });

      if (name === "imagePath" && !files.length) {
        setImagePreview(`${value.startsWith("/") ? value : `/${value}`}`);
      }
    }
  };

  const imageName = imagePreview ? imagePreview.split("/").pop() : "";

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("image", newBlog.image);
    formData.append("title", newBlog.title);
    formData.append("description", newBlog.description);

    try {
      if (isEditing) {
        await axios.put(
          `${CONFIG.BASE_URL}/api/blogimages/images/${blogId}`,
          formData,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );

        toast.success("Blog updated successfully!", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      } else {
        await axios.post(`${CONFIG.BASE_URL}/api/blogimages/upload`, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        toast.success("Blog Added successfully!", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      }

      setTimeout(() => navigate("/blog-news"), 1500);
    } catch (error) {
      toast.error("Error adding/updating blog", {
        position: "top-right",
        autoClose: 3000,
      });
    }
  };

  return (
    <div className="modal-overlay event_and_blog admin_modal_preview">
      <div className="custom-modal-content">
        <ToastContainer />
        <h2 className="mt-0" style={{ color: "white" }}>
          {isEditing ? "Edit Blog" : "Add Blog"}
        </h2>

        {/* Show alert if present */}
        {alert && (
          <CustomAlert
            message={alert.message}
            onClose={() => setAlert(null)}
            type={alert.type}
          />
        )}

        <form className="m-0" onSubmit={handleSubmit}>
          <div className="custom-form-group d-flex">
            <label className="custom-label">Image</label>
            <span>:</span>
            <div className="upload_wrap">
              <div
                className="uploadimgsect"
                style={{
                  alignItems: "center",
                  padding: "20px",
                  marginBottom: "20px",
                }}
              >
                {imagePreview ? (
                  <>
                    {/* Image Preview */}
                    <img
                      src={imagePreview}
                      alt="Preview"
                      width="200"
                      style={{ marginBottom: "10px" }}
                    />

                    <div className="custom-form-group close_button">
                      <button
                        type="button"
                        className="btn"
                        onClick={() => {
                          setImagePreview("");
                          setNewBlog({ ...newBlog, image: null });
                        }}
                        style={{
                          display: "inline-block",
                          justifyContent: "center",
                          alignItems: "center",
                          cursor: "pointer",
                          padding: "15px",
                          color: "red",
                        }}
                      >
                        <FaTimes />
                      </button>
                    </div>

                    {/* Delete Button below the Image */}
                  </>
                ) : (
                  <div
                    className="custom-form-group "
                    style={{ alignItems: "center" }}
                  >
                    <div
                      className="w-100 attcta"
                      style={{ alignItems: "center", background: "#fff" }}
                    >
                      {/* Hidden File Input */}
                      <input
                        id="file-upload"
                        type="file"
                        name="image"
                        accept="image/*"
                        style={{ display: "none" }}
                        onChange={handleInputChange}
                      />

                      {/* Custom Button to Trigger File Input */}
                      <button
                        type="button"
                        className="custom-file-btn m-0"
                        onClick={() =>
                          document.getElementById("file-upload").click()
                        }
                      >
                        Add Image
                      </button>

                      {/* Display the File Name */}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="custom-form-group eb_title">
            <label className="custom-label">Title</label>
            <span>:</span>
            <input
              type="text"
              name="title"
              value={newBlog.title}
              style={{ background: "none", color: "white" }}
              onChange={handleInputChange}
              className="custom-input"
              required
            />
          </div>
          <div className="custom-form-group description_limit">
            <label className="custom-label">Description</label>
            <span>:</span>
            <textarea
              name="description"
              value={newBlog.description}
              style={{ background: "none", color: "white" }}
              onChange={handleInputChange}
              className="custom-textarea"
              required
            />
          </div>
          <div className="custom-form-group text-right">
            <button
              type="button"
              className="custom-btn-cancel"
              onClick={() => navigate("/blog-news")}
            >
              Cancel
            </button>
            <button type="submit" className="custom-btn-submit">
              {isEditing ? "Update" : "Submit"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddBlogForm;
